export class PessoaSenhaModel {
    constructor(
        public senhaAtual: string = '',
        public novaSenha: string = '',
        public repetirSenha: string = '',
    ) { }
}